import workoutService from "../services/workout.service";

const addWorkout = (workout: string, isCompleted: boolean, timestamp: number) => workoutService.addWorkout(workout, isCompleted, timestamp);
const updateWorkout = (id: string, workout: string, isCompleted: boolean) => workoutService.updateWorkout(id, workout, isCompleted);
const deleteWorkout = (id: string) => workoutService.deleteWorkout(id);

const workoutApi = { addWorkout, updateWorkout, deleteWorkout };

export default workoutApi;